export enum CashType {
    Available = 'Available cash',
    Unsettled = 'Unsettled cash',
    Margin = 'Margin available',
    MarketValue = 'Total market value',
    RmdCurrent = 'RMD current year',
    RmdYtd = 'RMD YTD',
    RmdRemaining = 'RMD remaining',
    trustPrincipalBalance = 'Principal balance',
    trustIncomeBalance = 'Income balance',
    contributionYtd = 'Contribution YTD',
    // PAL balance types
    OutstandingLoans = 'Outstanding Loan(s)',
    AvailableCredit = 'Available Credit',
    CreditLine = 'Credit Line',
    FinanceCharges = 'Finance Charges',
    TotalPaymentDue = 'Total Payment Due',
    PaymentDueDate = 'Payment Due Date'
  }